export const REFERRAL_STORAGE_KEY = 'lopaka_referral_code';
export const REFERRAL_LIFETIME_DISCOUNT_CODE = 'FERGH9PL6F';
export const REFERRAL_LIFETIME_DISCOUNT_ID = 'dsc_01m2s9b1nchhdm7f9bkcgxp7m2';

export type ReferralSummary = {
    code: string;
    paid_referrals: number;
    bonus_weeks_earned: number;
    lifetime_access: boolean;
    accepted_referral: boolean;
    lifetime_discount_eligible: boolean;
};

const REFERRAL_CODE_PATTERN = /^[A-Z0-9]{10}$/;

export function normalizeInvitationCode(value: string | null | undefined): string | null {
    const normalized = value?.trim().toUpperCase() ?? '';
    return REFERRAL_CODE_PATTERN.test(normalized) ? normalized : null;
}

export function captureInvitationCode(search: string, storage: Storage = localStorage): string | null {
    const code = normalizeInvitationCode(new URLSearchParams(search).get('ref'));
    if (code) storage.setItem(REFERRAL_STORAGE_KEY, code);
    return code;
}

export function buildInvitationLink(currentUrl: string, code: string): string {
    const url = new URL('/price', currentUrl);
    url.searchParams.set('ref', normalizeInvitationCode(code) ?? code);
    return url.toString();
}

export async function acceptStoredReferral(
    storage: Storage,
    accept: (code: string) => Promise<unknown>,
): Promise<void> {
    const code = normalizeInvitationCode(storage.getItem(REFERRAL_STORAGE_KEY));
    if (!code) return;
    await accept(code);
    storage.removeItem(REFERRAL_STORAGE_KEY);
}

export function getReferralBonusEnd(start: Date, days: number): Date {
    return new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate() + days + 1));
}
